module.exports = __webpack_public_path__ + "img/36f2a46.webp";